export enum ApplicationSetting {
  /* SCOPE */
  COST_PLUS = 'COST_PLUS',
  DELIVERABLE_DYNAMIC_FIELDS = 'DELIVERABLE_DYNAMIC_FIELDS',
  PREDICT__COMPANY_SCOPEMARK__COMPONENTS = 'PREDICT__COMPANY_SCOPEMARK__COMPONENTS',
  PREDICT__LIBRARY__COMPONENTS = 'PREDICT__LIBRARY__COMPONENTS',
  PREDICT__LIBRARY__DELIVERABLES = 'PREDICT__LIBRARY__DELIVERABLES',
  PREDICT__SCOPEMARK__COMPONENTS = 'PREDICT__SCOPEMARK__COMPONENTS',
  PREDICT__SCOPEMARK__DELIVERABLES = 'PREDICT__SCOPEMARK__DELIVERABLES',
  PREDICT__SCOPEMARK__DISCIPLINES = 'PREDICT__SCOPEMARK__DISCIPLINES',
  PREDICT__SCOPEMARK__TPCS = 'PREDICT__SCOPEMARK__TPCS',
  SCOPE__AGENCY_HOURS = 'SCOPE__AGENCY_HOURS',
  SCOPE__AGENCY_RATES = 'SCOPE__AGENCY_RATES',
  SCOPE__APPROVAL__STATUS_CLIENT = 'SCOPE__APPROVAL__STATUS_CLIENT',
  SCOPE__BENCHMARK_RATE_CARD = 'SCOPE__BENCHMARK_RATE_CARD',
  SCOPE__VIEW_RATES = 'SCOPE__VIEW_RATES',
  SCOPE__BREAKDOWN = 'SCOPE__BREAKDOWN',
  SCOPE__DELIVERABLE__COMPONENT_PRICE = 'SCOPE__DELIVERABLE__COMPONENT_PRICE',
  SCOPE__DETAILS = 'SCOPE__DETAILS',
  SCOPE__ENABLE_FEES = 'SCOPE__ENABLE_FEES',
  SCOPE__ENABLE_SCENARIO_PRICING = 'SCOPE__ENABLE_SCENARIO_PRICING',
  SCOPE__ENABLE_SECTION_FEES = 'SCOPE__ENABLE_SECTION_FEES',
  SCOPE__EXTRA_DESCRIPTION_FIELD = 'SCOPE__EXTRA_DESCRIPTION_FIELD',
  SCOPE__FIXED_COST_DELIVERABLE_EDITING = 'SCOPE__FIXED_COST_DELIVERABLE_EDITING',
  SCOPE__OUTPUT = 'SCOPE__OUTPUT',
  SCOPE__SHOW_COLLABORATORS_THUMBNAIL = 'SCOPE__SHOW_COLLABORATORS_THUMBNAIL',
  SCOPE__START_END_DATE = 'SCOPE__START_END_DATE',
  SCOPE__TYPE_VIEW = 'SCOPE__TYPE_VIEW',
  SCOPE_BY_ROLE__ENABLE = 'SCOPE_BY_ROLE__ENABLE',
  SCOPE_BY_SCENARIO = 'SCOPE_BY_SCENARIO',
  SCOPE_DYNAMIC_FIELDS = 'SCOPE_DYNAMIC_FIELDS',
  SCOPE_OUTPUT_DOCX__BLANK_TEMPLATE = 'SCOPE_OUTPUT_DOCX__BLANK_TEMPLATE',
  TIMELINE_VIEW__ENABLE = 'TIMELINE_VIEW__ENABLE',
  CHANGE_REQUEST = 'CHANGE_REQUEST',
  SCOPE__ENABLE_CHANGE_REQUEST = 'SCOPE__ENABLE_CHANGE_REQUEST',
  SCOPE__DUPLICATE_WITH_DIFFERENT_RATE_CARD = 'SCOPE__DUPLICATE_WITH_DIFFERENT_RATE_CARD',
  SCOPE__SHOW_CHECKBOX_FOR_DISPLAYING_DELIVERABLES_IN_OTHER_RATE_CARDS = 'SCOPE__SHOW_CHECKBOX_FOR_DISPLAYING_DELIVERABLES_IN_OTHER_RATE_CARDS',

  /* GLOBAL */
  GROUPS__GLOBAL = 'GROUPS__GLOBAL',
  CAPTCHA__ENABLE = 'CAPTCHA__ENABLE',
  SAML__GLOBAL = 'SAML__GLOBAL',
  CURRENCY_CONVERSION = 'CURRENCY_CONVERSION',

  /* SOW */
  SOW__GLOBAL = 'SOW__GLOBAL',
  SOW__OWNER = 'SOW__OWNER',
  SOW__RETAINED_HOURS = 'SOW__RETAINED_HOURS',
  SOW__ALLOW_EDITING_CLIENT = 'SOW__ALLOW_EDITING_CLIENT',

  /* DELIVERABLE */
  COMPONENT__ENABLE_FEES = 'COMPONENT__ENABLE_FEES',
  DELIVERABLE__ENABLE_FEES = 'DELIVERABLE__ENABLE_FEES',
  SCOPE__AGENCY_HOURS_AND_MINUTES = 'SCOPE__AGENCY_HOURS_AND_MINUTES',
  SCOPE__DELIVERABLE__COMPULSORY__STARTEND_DATE = 'SCOPE__DELIVERABLE__COMPULSORY__STARTEND_DATE',
  SCOPE__DELIVERABLE__OWNER = 'SCOPE__DELIVERABLE__OWNER',
  SCOPE__DELIVERABLE__STARTEND_DATE = 'SCOPE__DELIVERABLE__STARTEND_DATE',
  SCOPE__DELIVERABLE__TRADING = 'SCOPE__DELIVERABLE__TRADING',
  SCOPE__MARGIN_SHOW = 'SCOPE__MARGIN_SHOW',
  SCOPE__MARKUP_SHOW = 'SCOPE__MARKUP_SHOW',

  /* COMPANY */
  COMPANY_CHILD_ACCOUNT_ACCESS_RULES = 'COMPANY_CHILD_ACCOUNT_ACCESS_RULES',
  FEE_ITEM__ENABLE = 'FEE_ITEM__ENABLE',
  RATECARD__IMPORT_EXPORT = 'RATECARD__IMPORT_EXPORT',
  RATECARD__SCOPEMARK__HIDE = 'RATECARD__SCOPEMARK__HIDE',
  RATECARD__SCOPEMARK__RATES = 'RATECARD__SCOPEMARK__RATES',
  RATECARD_LOCATION__ENABLE = 'RATECARD_LOCATION__ENABLE',
  SUPPORT_BUTTON__ENABLE = 'SUPPORT_BUTTON__ENABLE',

  /* TRAFFICKING */
  INTEGRATION_RESOURCE_MANAGEMENT = 'INTEGRATION_RESOURCE_MANAGEMENT',
  SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS = 'SCOPE__TRAFFICKING__DELIVERABLE_ACTUALS',
  TRAFFIC__IMPORTS_AUTO_SYNC = 'TRAFFIC__IMPORTS_AUTO_SYNC',
  TRAFFICKABLE_ON_STATUS__AGREE = 'TRAFFICKABLE_ON_STATUS__AGREE',
  TRAFFICKABLE_ON_STATUS__DRAFT = 'TRAFFICKABLE_ON_STATUS__DRAFT',
  TRAFFICKABLE_ON_STATUS__REVIEW = 'TRAFFICKABLE_ON_STATUS__REVIEW',

  /* DOCUSIGN */
  DOCUSIGN_OUTPUT_ON_AGREEMENT = 'DOCUSIGN_OUTPUT_ON_AGREEMENT',
  DOCUSIGN_OUTPUT_ON_CLIENT_ACCEPTED = 'DOCUSIGN_OUTPUT_ON_CLIENT_ACCEPTED',
  DOCUSIGN_OUTPUT_ON_CLIENT_APPROVAL = 'DOCUSIGN_OUTPUT_ON_CLIENT_APPROVAL',
  DOCUSIGN_OUTPUT_ON_DRAFT = 'DOCUSIGN_OUTPUT_ON_DRAFT',
  DOCUSIGN_OUTPUT_ON_REVIEW = 'DOCUSIGN_OUTPUT_ON_REVIEW',
  DOCUSING_OUTPUT_ON_CLOSED = 'DOCUSING_OUTPUT_ON_CLOSED',

  /* ADOBESIGN */
  ADOBESIGN_OUTPUT_ON_AGREEMENT = 'ADOBESIGN_OUTPUT_ON_AGREEMENT',
  ADOBESIGN_OUTPUT_ON_CLIENT_ACCEPTED = 'ADOBESIGN_OUTPUT_ON_CLIENT_ACCEPTED',
  ADOBESIGN_OUTPUT_ON_CLIENT_APPROVAL = 'ADOBESIGN_OUTPUT_ON_CLIENT_APPROVAL',
  ADOBESIGN_OUTPUT_ON_CLOSED = 'ADOBESIGN_OUTPUT_ON_CLOSED',
  ADOBESIGN_OUTPUT_ON_DRAFT = 'ADOBESIGN_OUTPUT_ON_DRAFT',
  ADOBESIGN_OUTPUT_OPTIONAL_COMPANY_SIGNER = 'ADOBESIGN_OUTPUT_OPTIONAL_COMPANY_SIGNER',
  ADOBE_ACCOUNT_BASE_NOTIFICATION = 'ADOBE_ACCOUNT_BASE_NOTIFICATION',
  ADOBESIGN_OUTPUT_ON_REVIEW = 'ADOBESIGN_OUTPUT_ON_REVIEW',

  /* LOGIN */
  USE_SSO_LOGIN_ONLY = 'USE_SSO_LOGIN_ONLY',
}
